export enum PageRankingActionTypes {
  FETCHING = 'pageRanking/FETCHING',
  RECEIVED = 'pageRanking/RECEIVED ',
  ERROR = 'pageRanking/FETCH-ERROR',
  FETCHING_VIEWER_RANKING = 'pageRanking/FETCHING_VIEWER_RANKING',
  RECEIVED_VIEWER_RANKING = 'pageRanking/RECEIVED_VIEWER_RANKING',
  ERROR_VIEWER_RANKING = 'pageRanking/FETCH-ERROR_VIEWER_RANKING',
}
